import React, { useContext } from 'react';
import { UIContext, IUiContext } from 'context/ui';

import { Link as GatsbyLink } from 'gatsby';

interface ILinkProps {
  children?: any;
  to?: string;
  className?: string;
  target?: string;
  onClick?: (e: React.SyntheticEvent) => void;
  transition?: boolean;
}

export const Link = ({
  children,
  to,
  className,
  onClick: customOnClick,
  target,
  transition = true,
  ...props
}: ILinkProps): React.ReactElement => {
  if (!to) {
    return children;
  }

  const { setCanTransition, navOpen, toggleNav, searchOpen, toggleSearch } = useContext<IUiContext>(UIContext);

  const isExternal = /^((https?:)?\/\/|[0-9a-zA-Z]+:)/.test(to || '');
  const onClick = (e: React.SyntheticEvent) => {
    let isPropagationStopped = false;

    // If a custom onClick handler doesn't want the link to do the transition stuff it should call
    // e.stopPropagation()
    if (customOnClick) {
      customOnClick(e);

      isPropagationStopped = e.isPropagationStopped && e.isPropagationStopped();
    }

    if (!isExternal) {
      if (navOpen) {
        setTimeout(() => {
          toggleNav(false);
        }, transition ? 500 : 0);
      }
      
      if (searchOpen) {
        toggleSearch(false);
      }
      setCanTransition(transition);
    }

    if (isPropagationStopped) {
      return;
    }
  };

  if (isExternal) {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={to}
        onClick={onClick}
        className={className}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <GatsbyLink {...props} to={to} className={className} onClick={onClick} state={{ transition }}>
      {children}
    </GatsbyLink>
  );
};
